import { render, staticRenderFns } from "./translationAudio.vue?vue&type=template&id=72d7a3fb&scoped=true"
import script from "./translationAudio.vue?vue&type=script&lang=js"
export * from "./translationAudio.vue?vue&type=script&lang=js"
import style0 from "./translationAudio.vue?vue&type=style&index=0&id=72d7a3fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7a3fb",
  null
  
)

export default component.exports